import * as types from "../../constants/actionTypes";

export const setLoader = (data) => {
  return {
    type: types.DASHBOARD_SET_LOADER,
    payload: data,
  };
};

export const getListReservasi = (value) => {
  return {
    type: types.GET_LIST_RESERVASI,
    value,
  };
};

export const acceptReservasi = (id, isAccept) => {
  return {
    type: types.DASHBOARD_ADMISI_ACCEPT_RESERVASI,
    id,
    isAccept,
  };
};

export const reportKunjunganPasien = (value) => {
  return {
    type: types.DASHBOARD_ADMISI_LISTDATA_KUNJUNGAN_PASIEN,
    value,
  };
};

export const pemasukanHarian = () => {
  return {
    type: types.DASHBOARD_ADMISI_PEMASUKAN_HARIAN,
  };
};

export const handleStateOuter = (property, value) => {
  return {
    type: types.HANDLE_STATE_OUTER,
    property,
    value,
  };
};
